import { styled } from "styled-components";

import { colorCSS, fontSizes } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const ShareButtons = styled.div`
    ${redundantCssFromKebab("display", "grid")}
    ${redundantCssFromKebab("grid-template-columns", "max-content")}
    ${redundantCssFromKebab("margin", "-0.5rem 0 0 -0.5rem")}
    ${redundantCssFromKebab("width", "calc(100% + 0.5rem)")}
    ${redundantCssFromKebab("padding", "0.5rem 0 0.5rem 0")}

    > * {
        ${redundantCssFromKebab("margin", "0.5rem 0 0 0.5rem")}
    }

    @media screen and (min-width: 576px) {
        ${redundantCssFromKebab("display", "flex")}
        ${redundantCssFromKebab("flex-wrap", "wrap")}
    }
`;

export const ShareInput = styled.input`
    ${redundantCssFromKebab("background-color", `${colorCSS("N20")}`)}
    ${redundantCssFromKebab("border", `1px solid ${colorCSS("N60")}`)}
    ${redundantCssFromKebab("border-radius", "0.3rem")}
    ${redundantCssFromKebab("color", `${colorCSS("N400")}`)}
    ${redundantCssFromKebab("display", "block")}
    ${redundantCssFromKebab("margin-bottom", "1rem")}
    ${redundantCssFromKebab("padding", "0.5rem 0.75rem")}
    ${redundantCssFromKebab("width", "100%")}
`;

export const ShareLabel = styled.label`
    ${redundantCssFromKebab("color", `${colorCSS("N100")}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("display", "block")}
`;
